(() => {
  const SECTION_SELECTOR = '[data-mt-website-services]';

  /** @param {number} n @param {number} min @param {number} max */
  function clamp(n, min, max) {
    return Math.min(Math.max(n, min), max);
  }

  /** @param {HTMLElement} section */
  function bindSection(section) {
    if (!(section instanceof HTMLElement)) return;

    let rafId = 0;

    function update() {
      rafId = 0;
      const rect = section.getBoundingClientRect();
      const vh = window.innerHeight || document.documentElement.clientHeight || 1;

      // section 顶部从视口底部进入到到达视口顶部，进度 0 -> 1
      const progress = clamp((vh - rect.top) / vh, 0, 1);
      // 先执行标题动画，再执行 2/4 图片抬升动画
      const headingProgress = clamp(progress / 0.45, 0, 1);
      const cardGrowProgress = clamp((progress - 0.45) / 0.55, 0, 1);

      section.style.setProperty('--mt-ws-heading-progress', headingProgress.toFixed(4));
      section.style.setProperty('--mt-ws-even-grow', cardGrowProgress.toFixed(4));
    }

    function requestUpdate() {
      if (rafId) return;
      rafId = window.requestAnimationFrame(update);
    }

    update();
    window.addEventListener('scroll', requestUpdate, { passive: true });
    window.addEventListener('resize', requestUpdate, { passive: true });
  }

  document.addEventListener('DOMContentLoaded', () => {
    const sections = document.querySelectorAll(SECTION_SELECTOR);
    if (!sections.length) return;
    sections.forEach(bindSection);
  });
})();
